// extracted by mini-css-extract-plugin
export default {"logo":"LoginForm_logo__nCraC"};